import { createSlice } from "@reduxjs/toolkit";
import { searchNurseServices } from "../../reducer/searchNurseServices/searchNurseServicesReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const searchNurseServicesSlice = createSlice({
  name: "searchNurseServices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchNurseServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchNurseServices.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchNurseServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default searchNurseServicesSlice.reducer;
